module.exports = __webpack_public_path__ + "prod/1.42.2/img/serve-one.0250533a.png";